<template>
    <div class="col-12">
        <hr class="line-break" />
    </div>

    <SummaryField
        :label="label"
        :value="value"
        :has-error="hasError"
        @edit="edit"
    />
</template>

<script>
export default {
    emits: ["edit"],
    props: {
        label: null,
        value: null,
        hasError: null
    },
    methods: {
        edit() {
            this.$emit("edit")
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/responsive';
@import '~scss/settings/variables';
@import '~scss/mixins/rem';

.line-break {
    margin: 9px 0px 13px;
}
</style>
